export default "__VITE_ASSET__Cv09LW_r__"